import { ReactNode } from "react";

import ReactTooltip, { TooltipProps } from "react-tooltip";
import styled from "styled-components";

type ToolTipProps = {
  id: string;
  children: ReactNode | ReactNode[];
  HoverComponent: any;
  toolTipProps?: TooltipProps;
  customContainerStyles?: Record<string, any>;
  hoverComponentProps?: Record<string, any>;
};

const TooltipContentContainer = styled.div`
  max-width: 215px;
  font-size: 12px;
  padding: 4px 8px;
`;

export default function ToolTip({
  children,
  id,
  HoverComponent,
  hoverComponentProps = {},
  toolTipProps = {
    place: "bottom",
    effect: "solid",
    border: true,
    borderColor: "black",
    backgroundColor: "black",
    textColor: "white",
  },
  customContainerStyles = {
    position: "relative",
  },
}: ToolTipProps) {
  const idWithoutSpaces = id.replace(/\s/g, "-");

  const { borderRadius } = customContainerStyles;

  return (
    <>
      <style>{`
        .tooltip-reset-styles {
          padding: 0px !important;
          white-space: normal !important;
           ${borderRadius ? `border-radius: ${borderRadius} !important;` : ""}
        }
      `}</style>
      <HoverComponent {...hoverComponentProps} style={{ cursor: "pointer" }} data-tip data-for={idWithoutSpaces} />
      <ReactTooltip className={`tooltip-reset-styles`} {...toolTipProps} id={idWithoutSpaces} aria-haspopup="true">
        <TooltipContentContainer style={{ ...customContainerStyles }}>{children}</TooltipContentContainer>
      </ReactTooltip>
    </>
  );
}
